// extracted by mini-css-extract-plugin
export var borderRadius = "_99-4";
export var large = "_99-3";
export var logoContainer = "_99-0";
export var nameLogo = "_99-2";
export var small = "_99-1";